import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";
import {ColorUtils} from "../../utils/ColorUtils";
import {ItemComponent} from "../../player/item.component";
import {SceneComponent} from "../scene/scene.component";

@Component({
  selector: 'app-stock-item',
  template: '<div #component></div>',
  styleUrls: []
})
export class StockItemComponent extends ItemComponent {
  negativeColor;

  constructor(protected  injector: Injector) {
    super(injector);
    this.folder = 'stock';
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.genericElm==null) {
          this.genericElm = new GenericElm(this.component);
        }
        this.fieldType = 'text';
        this.fieldName = this.data.StockItem[0].$.field;
        if (this.fieldName == 'Symbol') {
          this.fieldName = "symbol";
        }


        const font = this.data.StockItem[0].Font[0].$;
        this.negativeColor =  '#' + ColorUtils.format(Number(this.data.StockItem[0].$.negativeColor));
        this.genericElm.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font);
      }),
      switchMap(r=> {
        return this.invalidateData((<SceneComponent>this.parentPlayer).childProviderData, false);
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  invalidateText(value): Observable<any> {
    let label = "";
    if (this.fieldName == 'Percentage') {
      const change = Number(this.providerData['Change']);
      const last = Number(this.providerData['LastTrade']);
      const value = change / (last - change) * 100;
      label = value.toFixed(2) + '%';
    } else if (this.fieldName == 'LastTrade' || this.fieldName == 'Change' || this.fieldName == 'Open' || this.fieldName == 'Max' || this.fieldName == 'Min') {
      label = this.providerData[this.fieldName].toFixed(2);
    } else {
      label = this.providerData[this.fieldName];
    }
    if (Number(this.providerData.Change) < 0) {
      this.genericElm.fontStyle.fill = this.negativeColor;
    }
    this.genericElm.setText(label);
    return of('text');
  }

}
